<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :href="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>ข้อมูลเครื่อง</div>
        <div>
        </div>

      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :href="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div class="form_action" >
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >

          <v-text-field
              v-model="company"
              :rules="[v => !!v || 'กรุณากรอกชื่อบริษัท']"
              label="ชื่อบริษัท"
              required
          ></v-text-field>

          <v-textarea
              v-model="address"
              :rules="[v => !!v || 'กรุณากรอกข้อมูลบริษัท']"
              label="ข้อมูลบริษัท"
              required
          ></v-textarea>


          <h3 align="center" >รายชื่ออีเมลผู้รับรายงาน ({{ email_list.length }} ) คน</h3>

          <v-row class="mt-8"  >



            <v-col v-for="(result,index) in email_list" :key="result.id" cols="12" xl="3" lg="6" md="6" sm="12" xs="12" >

              <div class="card_email" >

                <v-text-field
                    v-model="result.email"
                    :rules="[v => !!v || 'กรุณากรอกอีเมล']"
                    label="อีเมล"
                    required
                ></v-text-field>

                <v-row>
                  <v-col>
                    <v-checkbox
                        v-model="result.cronjob"
                        label="ทุกวัน"
                        value="1"
                    ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox
                        v-model="result.cronjob"
                        label="ทุกสัปดาห์"
                        value="2"
                    ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox
                        v-model="result.cronjob"
                        label="ทุกเดือน"
                        value="3"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <button @click="RemoveEmailList(index)" type="button" class="close" >X</button>
              </div>


            </v-col>


          </v-row>

          <div align="center" class="mt-8" >

          <button type="button" @click="AddEmailList" class="plus btn-primary-custom" >เพิ่มข้อมูล email </button>

          </div>


          <v-row>
              <v-file-input
                  @change="Preview_imageLogo"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="เลือก รูปโลโก้บริษัท"
                  prepend-icon="mdi-camera"
                  label="รูปโลโก้บริษัท"
              ></v-file-input>
          </v-row>

          <div class="image_preview_container" >
            <img  id="image_preview_logo" src=""  />
          </div>

          <p class="note">แนะนำให้ใช้รูปภาพพื้นหลังโปร่งใส ขนาดอัตราส่วน 1:1</p>

          <v-text-field
              v-model="title"
              :rules="[v => !!v || 'กรุณากรอกชื่อเครื่อง']"
              label="ชื่อเครื่อง"
              required
          ></v-text-field>



          <v-row>
            <v-col>

              <v-file-input
                  @change="Preview_imageScreenServer"
                  :rules=" !this.edit && [v  =>(!!v    ||  'กรุณาอัพโหลดรูป') ]"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="เลือก รูปพักหน้าจอ"
                  prepend-icon="mdi-camera"
                  label="รูปพักหน้าจอ"
              ></v-file-input>

              <div class="image_preview_container" >
                <img  id="image_preview_screen_server" src=""  />
              </div>
              <p class="note">แนะนำให้ใช้รูปขนาด 1920 x 1080 สำหรับภาพพักหน้าจอ</p>
            </v-col>
            <v-col>

              <v-file-input
                  @change="Preview_imageBackground"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="เลือก รูปพื้นหลัง"
                  prepend-icon="mdi-camera"
                  label="รูปพื้นหลัง"
              ></v-file-input>

              <div class="image_preview_container" >
                <img  id="image_preview_background" src=""  />
              </div>
              <p class="note">แนะนำให้ใช้รูปขนาด 1920 x 1080 สำหรับภาพพักหน้าจอ</p>
            </v-col>
          </v-row>



          <v-file-input
              @change="Preview_image"
              :rules=" !this.edit && [v  =>(!!v    ||  'กรุณาอัพโหลดรูป') ]"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="เลือก รูปเครื่อง"
              prepend-icon="mdi-camera"
              label="รูปเครื่อง"
          ></v-file-input>

          <div class="image_preview_container" >
            <img  id="image_preview" src=""  />
          </div>

          <div align="center" style="margin-top: 2rem" >
            <v-btn v-if="!edit"
                class="mr-4 btn-primary-custom"
                @click="validate"
            >
              บันทึกข้อมูล
            </v-btn>

            <v-btn v-if="edit"
                   class="mr-4 btn-primary-custom"
                   @click="validate"
            >
              บันทึกข้อมูล
            </v-btn>

            <v-btn
                class="mr-4 btn-cancel-custom"
                @click="reset"
            >
              ล้างค่า
            </v-btn>

            <v-btn v-if="edit"
                class="mr-4 btn-cancel-custom"
                @click="resetedit"
            >
              ยกเลิกแก้ไข
            </v-btn>


          </div>


        </v-form>
      </div>

    </div>
  </v-breadcrumbs>



</template>

<script>
import {
  AddMachine,
  DeleteDepartment,
  GetMachine,
  UpdateMachine,
} from "../../lib/controller";
import {baseUrl} from "../../const/api";
import $ from "jquery";



export default {
  name: "Users",
  data: () => ({
    baseUrl:baseUrl,
    valid: true,
    edit:false,
    id:false,
    file:"",
    file_logo:"",
    file_screen_server:"",
    file_background:"",
    title:"",
    machine_number:"",
    token:"",
    company:"",
    address:"",
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลเครื่อง',
        disabled: true,
        href: '/Department',
      },
    ],
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'รูปเครื่อง',
        align: 'start',
        sortable: false,
        value: 'image',
      },
      {
        text: 'รูป logo บริษัท',
        align: 'start',
        sortable: false,
        value: 'image_logo',
      },
      {
        text: 'รูปพื้นหลัง',
        align: 'start',
        sortable: false,
        value: 'image_bg',
      },
      {
        text: 'รูปพักหน้าจอ',
        align: 'start',
        sortable: false,
        value: 'image_screen_server',
      },
      { text: 'ชื่อ', value: 'title' },
      { text: 'ชื่อบริษัท', value: 'company' },
      { text: 'ที่อยู่', value: 'address' },
      { text: 'ชื่อ', value: 'title' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
    email_list:[],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {

  },
  created () {
    this.initialize()
    this.GetMachines()
  },

  methods: {
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      console.log(this.itemss)

      const user = JSON.parse(localStorage.getItem('user'));
      const machine_data = results.data.find((res)=> res.machine_number == user.machine_id )
      console.log(machine_data);

      this.editItem(machine_data);
      //this.getData()

    },
    AddEmailList(){
      const email_list = this.email_list;
      email_list.push({
        email:"",
        cronjob:[],
      })
      this.email_list = email_list;
    },
    RemoveEmailList(index){
      this.email_list.splice(index, 1);
    },
    async editItem(item) {
      this.edit = true;
      this.title = item.title;
      this.company = item.company;
      this.address = item.address;
      this.machine_number = item.machine_number;
      this.token = item.token;
      console.warn(item.email_list);

      if(item.email_list){
      this.email_list = JSON.parse(item.email_list);
      }

      this.id = item._id;
      $('#image_preview').attr('src', baseUrl+'/'+item.image.path.replace('media',''));
      if(item.bg){
        $('#image_preview_background').attr('src', baseUrl+'/'+item.bg.path.replace('media',''));
      }
      if(item.screen_server) {
        $('#image_preview_screen_server').attr('src', baseUrl + '/' + item.screen_server.path.replace('media', ''));
      }
      if(item.logo) {
        $('#image_preview_logo').attr('src', baseUrl + '/' + item.logo.path.replace('media', ''));
      }

    },
    async resetedit() {
      this.edit = false;
      this.title = "";
      this.id = "";
      $('#image_preview').attr('src',"");
    },
    async deleteItem(id){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.delete(id)
        }
      })

      ;
    },
    async Subcategory(id) {
      this.$router.push({ path: 'Subcategory/'+id })
    },
    initialize () {

    },
    async getData(){
      const { status,results } = await GetMachine();
      if(status === 200){
        this.resultData = results.data;
      }
    },
    async delete(id){
      let Swal = this.$swal;
      const { status } = await DeleteDepartment(id);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
        await this.getData()
      }
    },
   async validate () {
      console.log(this.file)
      if(this.$refs.form.validate()){
       await this.AddUpdate();
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    Preview_image(e) {
      if (e) {
        this.file = e;
        $('#image_preview').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
    Preview_imageLogo(e) {
      if (e) {
        this.file_logo = e;
        $('#image_preview_logo').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
    Preview_imageScreenServer(e) {
      if (e) {
        this.file_screen_server = e;
        $('#image_preview_screen_server').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
    Preview_imageBackground(e) {
      if (e) {
        this.file_background = e;
        $('#image_preview_background').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
   async AddUpdate(){

      console.log("AddUpdate")

     let formData = new FormData();
     formData.append("company",this.company);
     formData.append("address",this.address);
     formData.append("title",this.title);
     formData.append("machine_number",this.machine_number);
     formData.append("token",this.token);

     if (this.email_list) {
           formData.append("email_list", JSON.stringify(this.email_list));
     }

     let Swal = this.$swal;
      if(!this.edit){

        formData.append("machine_image",this.file);

        if(this.file_logo){
        formData.append("logo_image",this.file_logo);
        }

        if(this.file_screen_server){
          formData.append("screen_server_image",this.file_screen_server);
        }

        if(this.file_background){
          formData.append("background_image",this.file_background);
        }

        const { status  } = await  AddMachine(formData);
        if(status === 200){
          Swal({
            icon: 'success',
            title: 'Success',
          })
         await this.getData();
        }

      }else{

        if(this.file){
          formData.append("file",this.file)
        }

        if(this.file_logo){
          formData.append("logo_image",this.file_logo);
        }

        if(this.file_screen_server){
          formData.append("screen_server_image",this.file_screen_server);
        }

        if(this.file_background){
          formData.append("background_image",this.file_background);
        }

        const { status  } = await  UpdateMachine(this.id,formData);
        if(status === 200){

          Swal({
            icon: 'success',
            title: 'Success',
          })

          await this.getData();
        }

      }

    }
  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img_thumb{
  width:8rem;
  border-radius:10px;
  margin:0.2rem;
}
.form_action{
  padding-right: 5rem;
  padding-left: 5rem;
}
.image_preview_container{
  display: flex;
  justify-content: center;
  align-items: center;
}
#image_preview{
  width: 20rem;
  text-align: center;
  padding: 1rem;
}
#image_preview_logo{
  width: 20rem;
  text-align: center;
  padding: 1rem;
}
#image_preview_screen_server{
  width: 20rem;
  text-align: center;
  padding: 1rem;
}
#image_preview_background{
  width: 20rem;
  text-align: center;
  padding: 1rem;
}
.note{
  font-size: 0.8rem;
  color: #ff5454;
}
</style>
